import { Route } from 'vue-router'
import Conversations from './Conversations.vue'
import New from './New.vue'
import List from './List.vue'
import Upload from './Upload.vue'
import Log from './Log.vue'
import Transcription from '@/contexts/transcription/src/App.vue'

export const RouteConfig = [
  {
    path: '/',
    component: Conversations,
    name: 'conversations',
    props: function(route: Route) {
      return { conversationId: route?.params?.conversationId }
    },
    children: [
      {
        path: 'all',
        component: List,
        name: 'conversations-list'
      },
      {
        path: 'new',
        component: New,
        name: 'conversation-new'
      },
      {
        path: ':conversationId/log',
        component: Log,
        name: 'conversation-log',
        props: function(route: Route) {
          return { conversationId: route?.params?.conversationId }
        }
      },
      {
        path: ':conversationId/upload',
        component: Upload,
        name: 'conversation-upload',
        props: function(route: Route) {
          return { conversationId: route?.params?.conversationId }
        }
      },
      {
        path: ':conversationId/transcript',
        component: Transcription,
        name: 'conversation-transcript',
        props: function(route: Route) {
          return {
            transcriptionId: Number.parseInt(route?.params?.conversationId)
          }
        }
      },
      {
        path: ':conversationId/transcript/:version',
        component: Transcription,
        name: 'conversation-transcript-version',
        props: function(route: Route) {
          return {
            transcriptionId: Number.parseInt(route?.params?.conversationId),
            version: Number.parseInt(route?.params?.version)
          }
        }
      },
      {
        path: ':conversationId',
        component: New,
        name: 'conversation-details',
        props: function(route: Route) {
          return {
            conversationId: Number.parseInt(route?.params?.conversationId)
          }
        }
      },
      {
        path: '',
        component: List
      }
    ]
  }
]
